<template>
  <element>
    <AppBar :title="title" />
    <v-container class="pt-0">
      <v-icon class="page-icon" color="#2e384d" size=60>mdi-car-door</v-icon>
      <p class="desc">{{ $t('selectPartPage.description') }}</p>
      <LabelTextField 
        ref="filter" 
        :label="$t('selectPartPage.searchLabel')" 
        @change="filter"
      ></LabelTextField>
      <div class="scroll-area mt-3 mb-4">
        <PartTable 
          :headers="$t('selectPartPage.partTable.headers')" 
          :parts="filtered"
          :selectedPartsIds="selectedPartsIds"
          :displayItems="displayItems" 
          checkable
          @rowClick="itemClicked"
        ></PartTable>
      </div>
      <v-btn
        class="mt-3"
        color="#033e8c"
        height="45px"
        block
        depressed
        dark
        @click="complete"
        :disabled=disableCompleteButton
      >
        {{ completeBtnTitle }}
      </v-btn>
    </v-container>
  </element>
</template>

<script>
import AppBar from "@/components/common/AppBar.vue";
import LabelTextField from "@/components/common/LabelTextField.vue"
import PartTable from "@/components/common/PartTable.vue";

export default {
  name: "SelectPartPage",
  components: {
    AppBar,
    PartTable,
    LabelTextField,
  },
  data () {
    return {
      carId: null,
      parentId: null,
      partGroups: [],
      selectedPartGroup: null,
      partGroupOptions: null,
      parts: [],
      filtered: [],
      displayItems: ['name', 'oem_number'],
      selectedPartId: null,
      selectedPartsIds: [],
    }
  },
  created() {
    this.title = this.$store.getters.getCurrentTask.taskName

    const pid = this.$store.getters.getCurrentPID
    this.$store.dispatch('retrieveProcessVariables', pid)
    .then(response => {
      try {
        this.carId = response.data.data.car_id.value
        this.physical_location = response.data.data.physical_location.value

        let url = '/Parts/get?'

        if (this.physical_location) {
          url += 'physical_location=' + this.physical_location + '&'
        }

        if (this.carId) {
          url += 'car_id=' + this.carId + '&'
        }

        if (url.endsWith('&')) {
          url = url.slice(0, url.length - 1)
        }

        this.fetchParts(url)
      } catch (error) {
        console.log("Failed retrieving variables from API.", error)
      }
    })
    .catch(error => {
      console.log("Failed retrieving variables from API", error)
    })
  },
  computed: {
    disableCompleteButton()
    {
      if (!this.selectedPartId)
        return true
      else
        return false
    },
    completeBtnTitle()
    {
      return this.$store.getters.getCurrentTask.taskName
    }
  },
  methods: {
    filter(value) {
      const filter = value.toLowerCase()
      this.filtered = this.parts.filter(part => {
        if (part.oem_number?.toLowerCase().includes(filter) 
          || part.serial_number?.toLowerCase().includes(filter)
          || part.name?.toLowerCase().includes(filter)
          || part.description?.toLowerCase().includes(filter)) {
          return true
        }
        
        return false
      })
    },
    fetchParts(url) {
      this.axios.get(url, {}, { withCredentials: true })
      .then(response => {
        this.parts = response.data.data

        this.filtered = this.parts.map(e => {
          e["checked"] = false 
          return e
        })
  
      })
      .catch(error => {
        console.log("Failed retrieving parts", error)
      })
    },
    itemClicked(partId) {
        /* td 202009051853 #113 we need to use part_id, not the index */
        /* we also use the this.selectedPartIds as the single source of truth */
        // #128 td 202009160023 adapted this code for the single part selection

        console.log('itemClicked: ', partId)
        if (partId === this.selectedPartId)
        {
            this.selectedPartId=null
        } else {
            this.selectedPartId=partId
        }
        // putting a single element in the array ensures that PartTable will allow for a single item selection (without changing the core behaviour of that component)
        this.selectedPartsIds = [this.selectedPartId]
        
    },
    complete() {
      /* td 202009070100 #113 we need to use part_id globally, not on the filtered results */
      const variables = {
        "variables": {
          "part_id": {
            "value": JSON.stringify(parseInt(this.selectedPartId)),
            "type": "Integer"
          }
        }
      }
      
      const taskId = this.$store.getters.getCurrentTask?.id

      if (taskId) {
        this.$store.dispatch('completeTask', { taskId, variables })
        .then(response => {
          console.log("Task completed successfully!", taskId, response)
        })
        .catch(error => {
          console.log("Failed completing task!", taskId, error)
        })
      }
    }
  },
  watch: {},
}
</script>

<style scoped>
.group-label {
  font-size: 0.75rem;
  font-weight: bold;
  color: #b0bac9;
  text-align: left;
}

.scroll-area {
  height: 450px;
  overflow: auto;
}
</style>